import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field, CardTitle } from '@cordata/buffet';
import { Row, Col } from 'reactstrap';
import { useFormikContext } from 'formik';

import { store } from '~/utils/provider';

const Fields = ({ disabled, isAdd }) => {
  const { setFieldValue, values } = useFormikContext();
  const [providers, setProviders] = useState([]);
  const [locations, setLocations] = useState([]);
  const [isProvidersLoading, setIsProvidersLoading] = useState(true);

  useEffect(() => {
    setIsProvidersLoading(true);

    if (isAdd) {
      store.getAll({ summary: true })
        .then((r) => {
          setProviders(r);

          setIsProvidersLoading(false);
        });
    } else {
      setIsProvidersLoading(false);
    }
  }, [isAdd]);

  useEffect(() => {
    if (isAdd && values.provider?.id) {
      store.getOne(values.provider.id)
        .then((r) => {
          const { locations: locs } = r;

          setLocations(locs);

          if (locs.length === 1) {
            setFieldValue('preferredLocation', locs[0]);
          }
        });
    }
  }, [values.provider, isAdd]);

  return (
    <>
      {isAdd ? (
        <fieldset disabled={disabled}>
          <Row form>
            <Col sm>
              <Field
                name="provider"
                type="select"
                options={providers}
                getOptionValue={o => o.id}
                getOptionLabel={o => o.displayName}
                isLoading={isProvidersLoading}
                disabled={disabled}
              />
            </Col>

            <Col sm>
              <Field
                name="preferredLocation"
                type="select"
                options={locations}
                getOptionValue={o => o.id}
                getOptionLabel={o => o.providerLocationLabel}
                disabled={!locations.length}
              />
            </Col>
          </Row>
        </fieldset>
      ) : (
        <>
          <fieldset disabled={disabled}>
            <Row form>
              <Col sm>
                <Field
                  name="provider.displayName"
                  label="Display Name"
                  disabled
                />
              </Col>

              <Col sm>
                <Field
                  name="provider.npiNumber"
                  label="NPI Number"
                  disabled
                />
              </Col>

              <Col sm>
                <Field
                  name="provider.providerRoleLabel"
                  label="Specialist"
                  disabled
                />
              </Col>
            </Row>

            <Row form>
              <Col sm>
                <Field
                  name="provider.workPhone"
                  label="Office Number"
                  type="tel"
                  placeholder=""
                  disabled
                />
              </Col>

              <Col sm>
                <Field
                  name="provider.emailAddress"
                  label="Email"
                  type="email"
                  placeholder=""
                  disabled
                />
              </Col>
            </Row>
          </fieldset>

          <fieldset disabled={disabled}>
            <CardTitle>Preferred Location</CardTitle>

            <Field
              name="preferredLocation.providerLocationLabel"
              label="Label"
              disabled
            />

            <Row form>
              <Col sm={6}>
                <Field
                  name="preferredLocation.addr1"
                  label="Address 1"
                  placeholder=""
                  disabled
                />
              </Col>

              <Col sm={6}>
                <Field
                  name="preferredLocation.addr2"
                  label="Address 2"
                  placeholder=""
                  disabled
                />
              </Col>

              <Col sm={4}>
                <Field
                  name="preferredLocation.city"
                  label="City"
                  placeholder=""
                  disabled
                />
              </Col>

              <Col sm={4}>
                <Field
                  name="preferredLocation.provinceIso"
                  label="State"
                  placeholder=""
                  disabled
                />
              </Col>

              <Col sm={4}>
                <Field
                  name="preferredLocation.postCode"
                  label="Post Code"
                  placeholder=""
                  disabled
                />
              </Col>
            </Row>
          </fieldset>
        </>
      )}

      <fieldset disabled={disabled}>
        <Row form>
          <Col>
            <Field
              name="isPrimary"
              type="checkbox"
            />
          </Col>

          <Col>
            <Field
              name="isPcp"
              label="PCP"
              type="checkbox"
            />
          </Col>

          <Col>
            <Field
              name="careTeam"
              label="Current"
              type="checkbox"
            />
          </Col>
        </Row>
      </fieldset>
    </>
  );
};

Fields.propTypes = {
  disabled: PropTypes.bool,
  isAdd: PropTypes.bool,
};

Fields.defaultProps = {
  disabled: false,
  isAdd: false,
};

export default Fields;
